import init from "../js/lib/init";
import { initGiftWithPurchase } from "../js/lib/gift-with-purchase";
import { setupVue } from "../js/lib/vue-setup";
import "../js/lib/accessibility";
import stockists from "../js/sections/stockists";
import quiz from "../js/sections/quiz";
import collections from "../js/sections/collections";
import product from "../js/sections/product";
import blog from "../js/sections/blog";
import smoothScroll from "../js/lib/smoothScroll";
import bundle from "../js/sections/bundle";
import handleLocations from "../js/lib/handle-locations";
import tippy from "../js/lib/tippy";
import VideoModalHandler from "../js/lib/VideoModalHandler";

const runBraveFace = () => {
  setupVue();
  init();
  initGiftWithPurchase();

  if (document.querySelectorAll("#stockist-map").length > 0) {
    stockists();
  }

  if (document.querySelectorAll(".template-quiz").length > 0) {
    quiz();
  }

  handleLocations();
  collections();
  product();
  blog();
  smoothScroll();
  bundle();
  tippy();

  const calloutThreeUp = document.querySelectorAll(
    ".callout-three-up__product-item"
  );

  calloutThreeUp.forEach((item) => {
    const p = item.querySelectorAll("p");
    p.forEach((p) => {
      if (!p.innerText || p.innerHTML === "" || p.innerHTML == "&nbsp;") {
        p.remove();
      }
    });
  });

  const sixTabs = document.querySelectorAll(".six-up-image__tabs button");
  const middle = document.querySelector(".six-up-image-middle");

  if (sixTabs.length > 0) {
    sixTabs.forEach((el) => {
      el.addEventListener("click", function (e) {
        e.preventDefault();

        if (el.classList.contains("active")) {
          return;
        }

        const active = document.querySelector(".six-up-image__tabs .active");

        if (active) {
          active.classList.remove("active");
        }

        el.classList.add("active");

        if (el.classList.contains("youth")) {
          middle?.classList.remove("show--adult");
          middle?.classList.add("hide--adult");
        } else {
          middle?.classList.add("show--adult");
          middle?.classList.remove("hide--adult");
        }
      });
    });
  }

  const anchor = window.location.hash;

  if (anchor === "#cart") {
    const cartButton = document.querySelector("#header-cart-icon-button");

    if (cartButton) {
      (cartButton as HTMLElement)?.click();
    }
  }

  VideoModalHandler();

  const disable = document.querySelectorAll(".btn--no-action");

  if (disable.length > 0) {
    disable.forEach((el) => {
      el.addEventListener("click", function (e) {
        e.preventDefault();
      });
    });
  }

  const iframes = document.querySelectorAll(".wysiwyg__container iframe");

  if (iframes.length > 0) {
    iframes.forEach((el) => {
      const iframe = el as HTMLIFrameElement;
      if (iframe.width && iframe.height) {
        iframe.style.aspectRatio = `${iframe.width}/${iframe.height}`;
      }
    });
  }

  const reviews = document.querySelector("#fulfilled-reviews-all");
  const bucket = document.querySelector("#product-reviews__bucket");

  if (bucket && reviews) {
    bucket.appendChild(reviews);
  }

  document.body.classList.remove("not-loaded");
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    runBraveFace();
  });
} else {
  runBraveFace();
}
